import {EventVerteiler} from "../../global/eventVerteiler";
import {PATTERN_EVENTNAMES, PatternFactory} from "./patternFactory";
import {StockLogo} from "../selectableObjects";
import {HistoryController} from "../history/historyController";
import globalsObject from "../globalsObject";
import {PatternInEntwurf} from "./patternEntwurfsobjektInteractor";
import {ColorUtils} from "../colorUtils";
import {HistoryStep} from "../history/historyStep";
import {IHistoryStep} from "../history/IHistoryStep";


export class HistoryStepPatternSize extends HistoryStep implements IHistoryStep {
    private readonly colorCodeOnEntwurf: string;
    private readonly oldSize: number;
    private readonly newSize: number;

    public constructor(historyController: HistoryController, parameters) {
        parameters.type = "patternSizeChange";
        super(historyController, parameters);
        this.colorCodeOnEntwurf = parameters.colorCodeOnEntwurf;
        this.oldSize = parameters.oldSize;
        this.newSize = parameters.newSize;
    }

    redo() {
        EventVerteiler.broadcast(
            PATTERN_EVENTNAMES.SIZE_CHANGED,
            {
                colorCodeOnEntwurf: this.colorCodeOnEntwurf,
                newSize: this.newSize,
                oldSize: this.oldSize,
                ignoreInHistory: true
            }
        );
    }

    undo() {
        EventVerteiler.broadcast(
            PATTERN_EVENTNAMES.SIZE_CHANGED,
            {
                colorCodeOnEntwurf: this.colorCodeOnEntwurf,
                newSize: this.oldSize,
                oldSize: this.newSize,
                ignoreInHistory: true
            }
        );
    }
}


export class HistorystepPatternInserted extends HistoryStep implements IHistoryStep {
    private readonly stockLogo: StockLogo
    private baseColorValue: string;

    public constructor(historyController: HistoryController, parameters) {
        parameters.type = "patternInserted";
        super(historyController, parameters);
        this.stockLogo = parameters.stockLogo;
        this.baseColorValue = parameters.baseColorValue;
    }

    redo() {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.CREATED, {stockLogo: this.stockLogo, ignoreInHistory: true});
    }

    undo() {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.DELETED, {
            colorCodeNr: this.stockLogo.clampToColor,
            ignoreInHistory: true
        });
        EventVerteiler.broadcast("colorChangedEvent",
            {
                colorHexValue: ColorUtils.decToHex(parseInt(this.baseColorValue)),
                colorCode: globalsObject.controller.getColorCodeFromColorCodeNr(this.stockLogo.clampToColor),
                sentFromHistoryController : true
            }
        )
    }
}

export class HistorystepPatternDeleted extends HistoryStep implements IHistoryStep {
    private patternInEntwurf: PatternInEntwurf;

    public constructor(historyController: HistoryController, parameters: PatternInEntwurf) {
        super(historyController, {type: "patternDeleted", viewDetails: null});
        this.patternInEntwurf = parameters;
    }


    undo() {
        PatternFactory.createPattern(
            parseInt(this.patternInEntwurf.stockLogoID),
            this.patternInEntwurf.colors,
            globalsObject.controller.getColorCodeNr(this.patternInEntwurf.forColorCode),
            this.patternInEntwurf.tileWidthInCM
        );
    }

    redo() {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.DELETION_REQUEST, {colorCodeNr: globalsObject.controller.getColorCodeNr(this.patternInEntwurf.forColorCode)});
    }
}


export class HistoryStepPatternColorChange extends HistoryStep implements IHistoryStep {
    private readonly colorCodeOnEntwurf: string;
    private readonly colorCodeInPattern: string;
    private readonly newColorHex: string;
    private readonly oldColorHex: string;

    public constructor(historyController: HistoryController, parameters) {
        parameters.type = "patternColorChange"
        super(historyController, parameters);
        this.colorCodeOnEntwurf = parameters.colorCodeOnEntwurf;
        this.colorCodeInPattern = parameters.colorCodeInPattern;
        this.newColorHex = parameters.newColorHex;
        this.oldColorHex = parameters.oldColorHex;
    }

    redo() {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.REQUEST_COLOR_CHANGE, {
            colorCodeOnEntwurf: this.colorCodeOnEntwurf,
            colorCodeInPattern: this.colorCodeInPattern,
            newColorHexValue: this.oldColorHex,
            ignoreInHistory: true
        });
    }


    undo() {
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.REQUEST_COLOR_CHANGE, {
            colorCodeOnEntwurf: this.colorCodeOnEntwurf,
            colorCodeInPattern: this.colorCodeInPattern,
            newColorHexValue: this.oldColorHex,
            ignoreInHistory: true
        });
    }
}
